import axios from "axios";

export default {
  getPredictions() {
    return axios.get("/items/predictions").then(response => {
      return response.data.data.items;
    });
  }
};
